import { EasyField } from '../baseClasses/easyField';
import { FieldOptions, SelectOption } from '../index';

export class EasySelectKeyValueField<T> extends EasyField {
  controlType = 'select-key-value';

  constructor(options: FieldOptions<T> = {}) {
    super(options);
    options.controlType = this.controlType;
  }

  setItems(items: Array<T>) {
    this.items = items;
  }
}
